/* eslint-disable */

import {
  PropertyTypeGroupValues, CasaPropertyTypes, CommercialePropertyTypes, TerrenoPropertyTypes, StanzaPropertyTypes, GaragePropertyTypes,
} from '../../propertyTypes';
import { EmailContext, EmailPropertyType } from './types';

export const getEmailMessage = (type, context = EmailContext.DEFAULT, isProjectProfile) => {
  const emailPropType = getEmailPropTypeFromPropType(type, isProjectProfile);

  switch (context) {
    default:
    case EmailContext.DEFAULT:
      return `Ciao, quest${isEmailPropertyTypeFem(emailPropType) ? 'a' : 'o'} ${emailPropType} mi interessa e mi piacerebbe visitarl${isEmailPropertyTypeFem(emailPropType) ? 'a' : 'o'}. Grazie`;
    case EmailContext.TOUR:
      return `Ciao, quest${isEmailPropertyTypeFem(emailPropType) ? 'a' : 'o'} ${emailPropType} mi interessa e mi piacerebbe fare una prima visita virtuale. Grazie`;
    case EmailContext.NO_MEDIA:
      return 'Ciao, mi interessa però mi piacerebbe vedere altre foto. Grazie';
    case EmailContext.ATTIVITA:
      return 'Ciao, vorrei avere più informazioni su questa attività. Grazie';
  }
};
const getEmailPropTypeFromPropType = (label, isProjectProfile) => {
  if (isProjectProfile) {
    return EmailPropertyType.PROGETTO;
  }
  switch (label) {
    case PropertyTypeGroupValues.NUOVA_COSTRUZIONE:
      return EmailPropertyType.PROGETTO;
    case CasaPropertyTypes.APPARTAMENTO:
    case CasaPropertyTypes.ATTICO_MANSARDA:
    case CasaPropertyTypes.LOFT:
      return EmailPropertyType.APPARTAMENTO;
    case PropertyTypeGroupValues.STANZA:
    case StanzaPropertyTypes.STANZA:
      return EmailPropertyType.STANZA;
    case PropertyTypeGroupValues.GARAGE_POSTO_AUTO:
    case GaragePropertyTypes.GARAGE_POSTO_AUTO:
      return EmailPropertyType.GARAGE;
    case CommercialePropertyTypes.UFFICIO:
      return EmailPropertyType.UFFICIO;
    case CasaPropertyTypes.PALAZZO:
    case CommercialePropertyTypes.STABILE_PALAZZO:
      return EmailPropertyType.EDIFICIO;
    case PropertyTypeGroupValues.TERRENO:
    case TerrenoPropertyTypes.EDIFICABILE:
    case TerrenoPropertyTypes.AGRICOLO:
      return EmailPropertyType.TERRENO;
    case CommercialePropertyTypes.CAPANNONE:
      return EmailPropertyType.CAPANNONE;
    case CasaPropertyTypes.VILLA:
      return EmailPropertyType.VILLA;
    case CasaPropertyTypes.VILLETTA_SCHIERA:
      return EmailPropertyType.VILLETTA;
    case CasaPropertyTypes.BI_TRIFAMILIARE:
    case CasaPropertyTypes.CASA_INDIPENDENTE:
      return EmailPropertyType.CASA;
    default:
      return EmailPropertyType.IMMOBILE;
  }
};
const isEmailPropertyTypeFem = (type) => {
  switch (type) {
    case EmailPropertyType.STANZA:
    case EmailPropertyType.VILLA:
    case EmailPropertyType.VILLETTA:
    case EmailPropertyType.CASA:
      return true;
    default:
      return false;
  }
};
